
import { KYMW6800Model } from '../kymw6800.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * カテゴリ変換マスタ取得する
 *
 * @export API通信成功時の処理
 * @class GetCategoryConvListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCategoryConvListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6800Model;
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCategoryConvListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CategoryDiv: this.vo.categoryDiv,
        CategoryCode: this.vo.categoryCode,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW6800Model} model
   * @param {string} orderCode
   * @param {string} categoryLevel
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetCategoryConvListService
   */
  execute(model: KYMW6800Model, vo: any, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCategoryConvList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCategoryConvListService
   */
  success(data: any) {
    if (data !== null) {
      this.model.getGoodsCategory(data);
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
